module.exports = __webpack_public_path__ + "static/8_Connect-4cdc4a1b037fe23537b76b2b47a4fbff.jpg";